module.exports = __webpack_public_path__ + "static/calle-huertas-cdc115f5476c7e406eee436e28e27a58.jpg";